import * as React from 'react'
import { SVGProps } from 'react'

export const HamburgerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M2 2H22' stroke='currentColor' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M2 14H22' stroke='currentColor' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M2 8H22' stroke='currentColor' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
